import { makeStyles } from "@material-ui/core";

const colors = {
  mainBlue: '#5A73EC',
  mainLightBlue: '#1592b4'
}

export const useLoginStyles = makeStyles(theme => ({
  mainContainer: {
    justifyContent: 'center',
    padding: '3em 3em 2em 3em',
    [theme.breakpoints.up('md')]: {
      padding: '0',
      justifyContent: 'space-between'
    }
  },
  formContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.up('md')]: {
      width: '80%'
    }
  },
  root: {
    display: 'none',
    background:
      'linear-gradient(0deg, #84A3FF 0%, #3F69E4 0.01%, #1F35C8 100%)',
    [theme.breakpoints.up('md')]: {
      display: 'flex'
    }
  },
  title: {
    color: '#FFFFFF'
  },
  subTitle: {
    color: '#FFFFFF'
  },
  input: {
    margin: '15px 0 15px 0',
    outline: 0,
    '$:focus': {
      backgroundColor: 'black'
    }
  },
  line: {
    background: colors.mainBlue,
    with: '100%',
    height: 3,
    borderRadius: 100
  },
  text: {
    fontSize: 14,
    color: colors.mainBlue,
    margin: '5px 0 5px 0'
  },
  icon: {
    color: colors.mainBlue
  },
  titleLeft: {
    color: colors.mainBlue,
    fontSize: 40,
    fontWeight: 'bold',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  button: {
    color: '#FFF',
    backgroundColor: colors.mainBlue,
    width: '100%',
    height: 50,
    '&:hover': {
      backgroundColor: '#445fe4'
    }
  },
  buttonContato: {
    color: '#FFF',
    backgroundColor: colors.mainLightBlue,
    width: '100%',
    height: 50,
    '&:hover': {
      backgroundColor: '#107794'
    }
  },
  menu: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',

    '& #name': {
      fontSize: '.85em',
      textAlign: 'right',
      opacity: '.8'
    }
  },
  selectedMenu: {
    '& #name': {
      position: 'absolute',
      right: '3em',
      fontSize: '.85em',
      opacity: '.8'
    }
  }
}))